import { useTranslation } from "react-i18next";
import { Tooltip, styled, tooltipClasses } from "@mui/material";
import infoIcon from "assets/icons/info.svg";

const TooltipStyled = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(() => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "white",
    color: "rgba(0, 0, 0, 0.87)",
    boxShadow: "black",
    fontSize: 11,
  },
}));

const InnerStyled = styled("div")({
  width: "300px",
  padding: "0.5rem",
  "& ul": {
    listStyle: "none",
    "& li": {
      paddingBottom: "0.5rem",
      "& .instructions": {
        marginLeft: "10px",
        marginTop: "4px",
        fontWeight: 400,
      },
    },
  },
});

const FieldAnalysisHelperOverlay = () => {
  const { t } = useTranslation();
  return (
    <TooltipStyled
      placement="right-start"
      title={
        <InnerStyled>
          <h4>{t("AnalysisResults.SamplePoints.Title")}</h4>
          <br />
          <ul>
            <li>
              {t("AnalysisResults.SamplePoints.Add.Title")}
              <div className="instructions">
                {t("AnalysisResults.SamplePoints.Add.Instructions")}
              </div>
            </li>
            <li>
              {t("AnalysisResults.SamplePoints.Move.Title")}
              <div className="instructions">
                {t("AnalysisResults.SamplePoints.Move.Instructions")}
              </div>
            </li>
            <li>
              {t("AnalysisResults.SamplePoints.Delete.Title")}
              <div className="instructions">
                {t("AnalysisResults.SamplePoints.Delete.Instructions")}
              </div>
            </li>
          </ul>
        </InnerStyled>
      }
    >
      <img src={infoIcon} alt="info-icon" width="28px" />
    </TooltipStyled>
  );
};

export default FieldAnalysisHelperOverlay;
